export default __webpack_public_path__ + "static/media/badge.1ad45236.svg";